import { create } from 'zustand';

export type EditorTab = 'editor' | 'diff' | 'browser' | 'screenshots' | 'canvas' | 'syntara';

interface EditorStore {
  activeTab: EditorTab;
  setActiveTab: (tab: EditorTab) => void;
}

export const useEditorStore = create<EditorStore>((set) => ({
  activeTab: 'editor',
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
